import React, { useEffect, useState } from "react";
import Select from "react-select";
import clsx from "clsx";
import { motion, AnimatePresence } from "framer-motion";
import { Controller } from "react-hook-form";
import { NewDropdownArrowIcon } from "../../SVGs";
import ErrorTextWithIcon from "../../Typography/ErrorTextWithIcon/ErrorTextWithIcon";
import { AREA_FIELD } from "../../../Molecules/AddressDetailsForm/constants";
import TypographyPoppins from "../../TypographyPoppins";

const FloatingLabelSelect = ({
    errors,
    field,
    height = "",
    style = "",
    options,
    name,
    label,
    control = ([]) => { },
    isClearable,
    isSearchable,
    placeholder = "",
    setCustomerData,
    customerData,
    setValue,
}) => {
    const [shouldFloat, setShouldFloat] = useState(false);

    const DropdownIndicator = (props) => {
        const { selectProps } = props;
        const isOpen = selectProps.menuIsOpen;

        return (
            <AnimatePresence mode="wait">
                <motion.div
                    key="dropdown-arrow"
                    className="mr-2"
                    animate={{ rotate: isOpen ? 180 : 0 }}
                    exit={{ rotate: 0 }}
                    initial={false}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                    <NewDropdownArrowIcon />
                </motion.div>
            </AnimatePresence>
        );
    }

    const getCustomStyles = (error) => {
        return {
            option: (provided, state) => {
                return {
                    ...provided,
                    cursor: "pointer",
                    color: "#0A0D14",
                    background: state.isFocused ? "#FEF8F9" : "#fff",
                    fontWeight: state.isFocused ? "500" : "normal",
                    ':active': {
                        backgroundColor: "#E49DB3",
                    },
                };
            },
            menu: (provided) => {
                return {
                    ...provided,
                    backgroundColor: "#fff",
                    zIndex: 30,
                };
            },

            singleValue: (provided) => {
                return {
                    ...provided,
                    color: "#0A0D14",
                };
            },

            placeholder: (provided) => {
                return {
                    ...provided,
                    color: "grey",
                };
            },
            control: (provided, state) => {
                return {
                    ...provided,
                    // borderRadius: 4,
                    background: "transparent !important",
                    backgroundColor: "transparent !important",
                    // border: "1px solid #262626 !important",
                    border: "0px",
                    width: "100%",
                    height: "48px",
                    cursor: "pointer",
                    boxShadow: "none",
                };
            },
        };
    };

    const getCustomOptionLabel = (option) => {
        return (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span>{option?.label}</span>
                {option?.is_recommended && (
                    <div className="px-2 py-[6px] bg-Wisp_Pink rounded-[30px] outline outline-1 outline-offset-[-1px] outline-Pink_Rose inline-flex justify-center items-center">
                        <TypographyPoppins
                            text="Recommended"
                            className={" !text-xs "}
                        />
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="flex-1">
            <div
                className={` relative rounded-[1px] outline-1 outline-offset-[-1px] outline outline-[#ece9ee] h-[52px] ${height} ${style}`}
            >
                <div className=" absolute inset-x-0 -bottom-1">
                    <Controller
                        render={({
                            field: { onChange, value, onBlur, ref },
                            fieldState: { error },
                        }) => {
                            useEffect(() => {
                                setShouldFloat(!!value);
                            }, [value]);

                            return (
                                <Select
                                    styles={getCustomStyles(error?.message)}
                                    components={{
                                        DropdownIndicator: DropdownIndicator,
                                        IndicatorSeparator: null,
                                    }}
                                    isSearchable={isSearchable}
                                    value={value}
                                    placeholder={placeholder}
                                    options={options}
                                    onChange={(e) => {
                                        onChange(e);
                                        if (!!customerData) {
                                            setValue(AREA_FIELD, null);
                                            setCustomerData({
                                                ...customerData,
                                                selectedCity: e,
                                            });
                                        }
                                    }}
                                    getOptionLabel={getCustomOptionLabel}
                                    onFocus={() => setShouldFloat(true)}
                                    onBlur={(e) => {
                                        setShouldFloat(!!value);
                                        onBlur();
                                    }}
                                    isClearable={isClearable}
                                    inputRef={ref}
                                    ref={ref}
                                />
                            )
                        }}
                        name={name}
                        control={control}
                    />
                </div>
                <label
                    htmlFor={field}
                    className={clsx(
                        "absolute px-1 bg-white z-10 font-Poppins text-sm transition-all duration-300",
                        shouldFloat
                            ? "top-[2px] left-0 text-xs scale-90 text-gray-600"
                            : "top-[17px] text-sm left-2 text-gray-500"
                    )}
                >
                    {label}
                </label>
            </div>
            <ErrorTextWithIcon
                text={errors?.[field]?.message || errors?.[field]?.id?.message}
            />
        </div>
    );
};

export default FloatingLabelSelect;
